import { Component, Input, OnDestroy } from '@angular/core';
import { PageHeaderInterface } from '../../service/page-header/page-header.model';
import { LayoutConstants } from '../../../layout/layout-constants';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { PageHeaderStateInterface } from '../../../store/page-header/page-header.model';
import { IotDeviceManagementPortalAppState } from '../../../store/iotDeviceManagementPortalApp.reducer';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.scss'],
})
export class PageHeaderComponent extends LayoutConstants implements OnDestroy {
  @Input() pageHeader: PageHeaderInterface = {
    title: null,
    titleKey: null,
    icon: null,
    fullScreenButton: false,
    fullScreenTargetElementId: null,
    hideHeader: false
  };
  private readonly subscriptions: Subscription[] = [];
  public readonly pageConfigPages: string[] = [
    'device-management',
  ];
  public readonly pagesWithFilterBarVisibilityButton: string[] = [
    'device-management',
  ];

  public readonly pagesWithPrintFunctionality: string[] = ['root_cause_analysis_report'];
  public showPageConfig: number;
  public showFilterBarVisibilityButton: boolean = false;
  public showCountDownButton: boolean = false;
  public showPrintFunctionalityButton: boolean = false;
  public isPageConfigHidden: boolean = false;

  constructor(private readonly store: Store<IotDeviceManagementPortalAppState>) {
    super();
  }

  public ngOnInit(): void {
    this.showPageConfig = _.indexOf(this.pageConfigPages, this.pageHeader.titleKey);

    this.subscriptions.push(
      this.store.select('pageHeaderStore').subscribe((state: PageHeaderStateInterface) => {
        this.showFilterBarVisibilityButton =
          _.indexOf(this.pagesWithFilterBarVisibilityButton, this.pageHeader.titleKey) !== -1;
        this.showPrintFunctionalityButton =
          _.indexOf(this.pagesWithPrintFunctionality, this.pageHeader.titleKey) !== -1;
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((value: Subscription) => {
      value.unsubscribe();
    });
  }
}
